/* global angular */
( function () {
	'use strict';

	function manageShareService ( Session, apiService, $http ) {
		var credentials = Session.getCredentials();

		function getDistrictInfo () {
			return apiService.getHierarchy.get( {
				'id'   : credentials.ClientId,
				'type' : 'district'
			} ).$promise;
		}

		function getUsers ( data ) {
			return apiService.getHierarchy.get( {
				'id'   : data.ID,
				'type' : 'users'
			} ).$promise;
		}

		function getLocation () {
			return getDistrictInfo().then( getUsers );
		}

		function updatePrivilege ( templateId, type, id, payload ) {
			return apiService.templatePrivilege.update( {
				'type'       : type,
				'id'         : id,
				'templateId' : templateId
			}, payload ).$promise;
		}

		function deletePrivilege ( templateId, type, id, payload ) {
			delete payload.allow;

			// used $http instead of apiService $resource since
			// $resource DELETE method removes payload body automatically
			return $http( {
				'method'  : 'DELETE',
				'url'     : '/api/v1/' + type + '/' + id + '/permissions/observe/templates/' + templateId,
				'headers' : {
					'Content-Type' : 'application/json'
				},

				'data' : JSON.stringify( payload )
			} );
		}

		function getPrivilege ( templateId, type, id, inherited ) {
			return apiService.templatesPrivilege.get( {
				'type'       : type,
				'id'         : id,
				'templateId' : templateId,
				'inherited'  : inherited
			} ).$promise;
		}

		return {
			'getLocation'     : getLocation,
			'getPrivilege'    : getPrivilege,
			'updatePrivilege' : updatePrivilege,
			'deletePrivilege' : deletePrivilege
		};
	}

	angular
		.module( 'app.templates' )
		.factory( 'manageShareService', manageShareService );

	manageShareService.$inject = [ 'Session', 'apiService', '$http' ];
} )( );
